<template>
  <button
    type="button"
    :style="colorStyle"
    class="flex justify-center items-center size-[26px] rounded-full bg-[var(--user-color)]"
    :class="{ 'shadow-[inset_0_0_0_1px_white]': selected }"
    @click="changeColor"
  >
    <svg-icon
      v-if="selected"
      :fill="'#fff'"
      :width="'12'"
      :height="'12'"
      icon="app-icons/success"
    />
    <span class="sr-only">User color</span>
  </button>
</template>

<script>
import { computed } from 'vue';
import SvgIcon from '@ui/components/SvgIcon.vue';

export default {
  components: {
    SvgIcon,
  },
  props: {
    color: {
      type: String,
      default: null,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const { color } = props;

    const colorStyle = computed(() => ({
      '--user-color': color,
    }));

    return {
      colorStyle,
    };
  },

  methods: {
    changeColor() {
      this.$store
        .dispatch('user/account/updateColor', { color: this.color })
        .catch(error => {
          console.log(error);
        });
    },
  },
};
</script>
